<template>
  <div class="principal-body" style="height: 100%;overflow-y: auto;">
    <v-container align="center">
      <h1> {{ $t('WHAT IS BYPPAY') }}</h1>
      <p align="center">
        <b style="color: #44E0B2">Byppay </b> {{ $t('is a platform that facilitates payments to providers through potential customers in a fast, economical and secure way') }}
      </p>
      <h1>{{ $t('MoreInfo.HOW IT WORKS?') }}</h1>
      <p align="left">
        1. {{ $t('MoreInfo.Upload the invoice to be paid to the web-app') }}<br>
        2. {{ $t('MoreInfo.Request payment of the invoice to the customer you want') }}<br>
        3. {{ $t('MoreInfo.The app automatically negotiates a customer-provider agreement') }}<br>
        4. {{ $t('MoreInfo.You will receive a payment confirmation when the provider has paid the customer, as well as a certificate proving payment') }}<br>
      </p>
      <v-img style="alignment: center;height: 100%" src="../../public/wellcomeImages/BYPPAY-11.png" />
      <p>
        <b style="color: #44E0B2">Byppay.com </b> {{ $t('MoreInfo.is a digital platform that works worldwide and is VAT neutral. It allows you not to advance money to your provider without having received your client\'s income. These payments they are registered with DLT (Distribution Ledger Technology) which makes a valid and secure agreement possible.') }}
      </p>
      <p>
        {{ $t('MoreInfo.It is a financial solution that works with Ethereum which makes it a DeFi (Decentralized Finance) solution. By the end of 2021, more than 100,000 European SMEs will avoid bills thanks to the digitization of agreements and payments with DeFi solutions such as') }}
        <b style="color: #44E0B2">Byppay</b>.
      </p>
    </v-container>

    <v-container>
      <div class="container-video" style="width: 100%; display: flex;">
        <iframe class="video" src="https://www.youtube.com/embed/ulVBwwpMGvA?autoplay=1&mute=1&controls=1&rel=0&loop=1&modestbranding=1&showinfo=0" />
      </div>
    </v-container>

    <v-carousel
      hide-delimiter-background
      show-arrows-on-hover
      :show-arrows="false"
      height="70vh"
      :dark="darkMode"
      :light="!darkMode"
    >
      <v-carousel-item v-for="(img) in imgs" :key="img.img">
        <v-row align="center" justify="center">
          <v-col cols="12" style="text-align: center">
            <v-img style="height: 100%" :src="img.img" contain />
            <h1>{{ img.title }}</h1>
            <p><b>{{ img.description }}</b></p>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>

    <v-container>
      <v-row justify="center">
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>{{ $t('MoreInfo.What is an invoice?') }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ $t('MoreInfo.An invoice is a commercial document that indicates the sale of a good or service and that, among other things, must include all the information of the operation. It has legal and fiscal validity. We can say that it is an accreditation of a transfer of a product or service after purchasing it.') }}
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>{{ $t('MoreInfo.What is a byppay?') }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ $t('MoreInfo.Through the bypay mechanism, a company can pay the invoices to its suppliers with the invoices of its clients.') }}
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>{{ $t('What is a forward?') }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ $t('MoreInfo.It is the reverse procedure to bypay, through which a company invoices from clients (to be collected) can be sent to our suppliers to pay their invoices.') }}
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>{{ $t('What are the advantages of byppay / forward?') }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ $t('MoreInfo.The main benefit that the company obtains when executing this operation is to offset invoices. This, by extension, improves the financing capacity of the business.') }}
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>{{ $t('What is the blockchain?') }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ $t('MoreInfo.It is the technology that ensures that the actions related to a bypay / factoring are registered without the possibility of being altered in the future. Certify the validity of the process.') }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
    name: "MoreInfo",
    data () {
        return {
            imgs: [{img: "/wellcomeImages/1.png", title: this.$t('MoreInfo.FAST, CHEAP & SAFE'), description: this.$t('MoreInfo.You pay your invoices by bypaying income directly to your providers. No cash, no funding are needed. The app uses DLT/Blockchain to secure the byppay agreements')}, {img: "/wellcomeImages/2.png", title: this.$t('MoreInfo.HOW DOES IT WORK?'), description: this.$t('MoreInfo.Upload your providers and clients invoices into the app. The app will propose byppaying some invoices: When your clients pay directly to your providers, you have paid then indeed, and invoices compensated!')}, {img: "/wellcomeImages/3.png", title: this.$t('MoreInfo.A NEW NORMAL'), description: this.$t('MoreInfo.Byppaying is the fastest, cheapest and safest funding in the market.')}],
            video: "/wellcomeVideos/byppay.mp4",
        };
    },
    computed: {
        darkMode () {
            return this.$vuetify.theme.dark;
        }
    },

};
</script>

<style>
    .v-item--active + span + .v-icon {
        color: #FF6961 !important;
    }
    .container-video {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;
    }
    .video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>
